import React from 'react';
import Hero from '../components/Hero';
import heroImage from '../assets/hero.jpg';
import donkeyLogo from '../assets/donkey_logo.png';
import './PrivateEvents.css';

const PrivateEvents: React.FC = () => {
  return (
    <div className="private-events-page">
      <Hero
        title="Private Events"
        image={heroImage}
        height="40vh"
        useClipPath={true}
        chevronLogo={donkeyLogo}
      />

      <main className="page-content text-center">
        <div className="container">
          <h2 style={{ fontFamily: 'Damion, cursive', fontSize: '3rem', marginTop: '2rem' }}>
            Coming Soon
          </h2>
        </div>
      </main>
    </div>
  );
};

export default PrivateEvents; 